"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBeefyAPIData = exports.BeefyApiEndpoint = void 0;
const axios_1 = __importDefault(require("axios"));
var BeefyApiEndpoint;
(function (BeefyApiEndpoint) {
    BeefyApiEndpoint["GetVaults"] = "vaults";
    BeefyApiEndpoint["GetFees"] = "fees";
    BeefyApiEndpoint["GetAPYs"] = "apy";
    BeefyApiEndpoint["GetTVLs"] = "tvl";
})(BeefyApiEndpoint = exports.BeefyApiEndpoint || (exports.BeefyApiEndpoint = {}));
const BEEFY_API_URL = 'https://api.beefy.finance';
const getBeefyAPIData = async (endpoint) => {
    const url = `${BEEFY_API_URL}/${endpoint}`;
    const rsp = await axios_1.default.get(url);
    return rsp.data;
};
exports.getBeefyAPIData = getBeefyAPIData;
